import { render } from "./InvoiceNotesDialog.vue?vue&type=template&id=15a186ca&ts=true"
import script from "./InvoiceNotesDialog.vue?vue&type=script&lang=ts"
export * from "./InvoiceNotesDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__